import { ReviewModeParams } from './../../communication-structure/review-mode-params';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChildren,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AutoTrainingCodeList } from '../../communication-structure/auto-training-code-list';
import { CommunicationProxyService } from '../../services/communication-proxy.service';
import { LoginService } from '../../services/login.service';
import { StringTableService } from '../../services/string-table.service';
import { CheckboxState } from '../chckbox/chckbox.component';
import {
  Accordion,
  AccordionRow,
  AccordionRowTypes,
} from '../data-accordion/data-accordion.component';
import { MainComponent } from '../main-component/main.component';
import { PageViewComponent } from '../page-view/page-view.component';
import { PieChartType } from '../pie-chart/pie-chart.component';
import { Table, Types } from '../table/table.component';
import { BaseComponent } from './../base/base.component';

@Component({
  selector: 'app-dashboard-home',
  templateUrl: './dashboard-home.component.html',
  styleUrls: ['./dashboard-home.component.scss'],
})
export class DashboardHomeComponent extends PageViewComponent implements OnInit {
  dataRefresher: any;
  selectedElement: any;
  public biddleEmailHref: string;
  public currentSelectedAccordion: any;
  public pieChartItemValue: any;
  public pieChartPieChartType: any;
  public popupState = false;
  public timeInvestedLabel: string;
  public timeInvested: string;
  public pageTitle: string;
  public atcProgressTitle: string;
  public dueDateTitle: string;
  public logoImgSrc = '';
  public biddleEmail: string;
  public trainingDeadlineTitle: string;
  public trainingDeadlineDate: string;
  public remainingDaysTitle: string;
  public remainingDays: string | number;
  public chartLabels = [];
  public legendData = [];
  public expandData = [];
  public portfolioPageTitle: string;
  public portfolioPageDesc: string;
  public autoTrainingCodeListTitle: string;
  public attemptDropdownOptions = [];
  public defaultAttemptOption: string;
  public accordianToDisplay: Accordion[] = [];
  public pieChartData: number[] = [];
  public totalAtcCount = 0;
  public checkboxLabels: string[] = [];
  public checkboxData = [];
  public legendBgColorArray: string[] = [];

  private autoTrainingCodeList: AutoTrainingCodeList[] = [];
  private totalAccordions: Accordion[] = [];
  private dataAccordion: Accordion;
  private tableHeader: Table[] = [];
  private displayTable: Table[][];
  private headerTitleArray: string[] = [];

  private allCheckBoxes;

  private candidateEmail: string;

  @ViewChildren('checkBox') private checkBoxArray;

  constructor(
    ele: ElementRef,
    protected remoteProxy: CommunicationProxyService,
    protected loginService: LoginService,
    protected stringTableService: StringTableService,
    protected router: Router,
    protected cdr: ChangeDetectorRef,
    private route: ActivatedRoute
  ) {
    super(ele, remoteProxy, loginService, stringTableService, router);
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const queryParam = this.stringTableService.getString('reviewModeParams', 'queryParam1');
      const queryData = params[queryParam] ? params[queryParam] : '';
      if (queryData !== '') {
        try{
          const mode = this.stringTableService.getString('reviewModeParams', 'mode');
          const dataObj: ReviewModeParams = JSON.parse(atob(decodeURIComponent(queryData)));
          BaseComponent.isReviewMode = dataObj.mode ? dataObj.mode === mode : false;
          this.reviewCandidateId = BaseComponent.isReviewMode && dataObj.candidateId ? dataObj.candidateId : '';
          this.candidateEmail = BaseComponent.isReviewMode && dataObj.candidateEmail ? dataObj.candidateEmail : '';
          if (this.isReviewMode && this.candidateEmail !== '') {
            this.biddleEmail = this.candidateEmail;
            this.biddleEmailHref = 'mailto:' + this.biddleEmail;
          }
        } catch (e) {
          BaseComponent.isReviewMode = false;
          this.reviewCandidateId = '';
          this.router.navigate(['home']);
        }
      }
      if (!BaseComponent.isReviewMode || this.reviewCandidateId === '' || this.candidateEmail === '') {
        BaseComponent.isReviewMode = false;
        this.reviewCandidateId = '';
        this.router.navigate(['home']);
      }
    });
    this.initView();
    this.getClientTrainingList();
    if (MainComponent.getAtcData() === undefined) {
      this.getAutoTrainingCodeList(1);
    } else {
      this.setAtcListData();
    }
    if (MainComponent.getTrainingList() === undefined) {
      this.getClientTrainingList();
    }
    this.refreshData();
  }

  refreshChanges() {
    this.completeATCCount = 0;
    this.inprogressATCCount = 0;
    this.unattemptedATCCount = 0;
    this.totalAccordions = [];
    this.tableHeader = [];
    this.noLoderFlag = true;
    this.getAutoTrainingCodeList(1);
    this.noLoderFlag = false;
  }

  refreshData() {
    this.dataRefresher = setInterval(() => {
      this.refreshChanges();
    }, 30 * 1000);
  }

  handleATCListData(data) {
    super.handleATCListData(data);
    this.setAtcListData();
  }

  initView() {
    this.pageTitle = this.stringTableService.getString(
      'dashboard-home',
      'pageTitle'
    );
    this.atcProgressTitle = this.stringTableService.getString(
      'dashboard-home',
      'atcProgressTitle'
    );
    this.biddleEmail = this.stringTableService.getString(
      'dashboard-home',
      'biddleEmail'
    );
    this.trainingDeadlineTitle = this.stringTableService.getString(
      'dashboard-home',
      'trainingDeadlineTitle'
    );
    this.remainingDaysTitle = this.stringTableService.getString(
      'dashboard-home',
      'remainingDaysTitle'
    );
    this.chartLabels = this.stringTableService.getArrayOfStrings(
      'dashboard-home',
      'chartLabels'
    );
    this.timeInvestedLabel = this.stringTableService.getString(
      'dashboard-home',
      'timeInvestedLabel'
    );
    this.portfolioPageTitle = this.stringTableService.getString(
      'portfolio-courses',
      'pageTitle'
    );
    this.portfolioPageDesc = this.stringTableService.getString(
      'portfolio-courses',
      'pageDesc'
    );
    this.autoTrainingCodeListTitle = this.stringTableService.getString(
      'report-courses',
      'autoTrainingCodeListTitle'
    );
    this.attemptDropdownOptions = this.stringTableService.getArrayOfStrings(
      'portfolio-courses',
      'attemptDropdownOptions'
    );
    this.defaultAttemptOption = this.attemptDropdownOptions[0].name;
    this.headerTitleArray = this.stringTableService.getArrayOfStrings(
      'portfolio-courses',
      'headers'
    );
    this.logoImgSrc = this.stringTableService.getString(
      'paths',
      'testgeniusLogo'
    );
    this.dueDateTitle = this.stringTableService.getString(
      'dashboard-home',
      'dueDateTitle'
    );
    this.checkboxLabels = this.stringTableService.getArrayOfStrings(
      'dashboard-home',
      'checkboxLabels'
    );
    this.checkboxData = [
      PieChartType.ALL,
      PieChartType.COMPLETED,
      PieChartType.INPROGRESS,
      PieChartType.UNATTEMPTED,
    ];
    this.legendBgColorArray = this.stringTableService.getArrayOfStrings(
      'dashboard-home',
      'bgColorArray'
    );

    if (this.isReviewMode && this.candidateEmail !== '') {
      this.biddleEmail = this.candidateEmail;
      this.biddleEmailHref = 'mailto:' + this.biddleEmail;
    } else if (this.remoteProxy.isApiReady) {
      this.biddleEmail = this.loginService.userInfo.profile.name;
      this.biddleEmailHref = 'mailto:' + this.biddleEmail;
    } else {
      this.biddleEmail = 'vmuh@biddle.com';
      this.biddleEmailHref = 'mailto:' + this.biddleEmail;
    }
    // document
    //   .getElementsByClassName('header-wrapper')[0]
    //   .getElementsByTagName('li')[0]
    //   .focus();
  }

  setAtcListData() {
    const data = this.getHandeledAtcData();
    this.trainingDeadlineDate = this.formatDate(
      this.dateConversion(data.dueDate)
    );
    this.remainingDays = this.calculateDaysDiff(data.dueDate);
    this.autoTrainingCodeList = data.autoTrainingCodeList;
    this.gatherData();
  }

  gatherData() {
    let timeInvestedTotal = 0;
    let dueDate;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.allCheckBoxes = this.checkBoxArray.toArray();
    for (const headerTitle of this.headerTitleArray) {
      this.tableHeader.push(new Table(Types.TEXT, 'table-header', headerTitle));
    }

    for (const atc of this.autoTrainingCodeList) {
      timeInvestedTotal += atc.timeInvested;
      if (atc.expirationDate) {
        if (
          dueDate === undefined &&
          this.dateConversion(atc.expirationDate) >= today
        ) {
          dueDate = atc.expirationDate;
        } else if (
          this.dateConversion(atc.expirationDate) <
            this.dateConversion(dueDate) &&
          this.dateConversion(atc.expirationDate) >= today
        ) {
          dueDate = atc.expirationDate;
        }
      }
      const accordionHeader = new AccordionRow(
        AccordionRowTypes.PIE_CHART_DASHBOARD,
        atc.autoTrainingCodeName,
        atc.desc,
        this.calcAtcCompletionPerc(atc.skillList),
        atc.applicationId,
        atc.expirationDate
          ? this.dateConversion(atc.expirationDate).getTime() > 0
            ? this.formatDate(this.dateConversion(atc.expirationDate))
            : 'N/A'
          : 'N/A'
      );
      const accordionData = new AccordionRow(
        AccordionRowTypes.POPUP_TABLE,
        this.tableHeader,
        this.formTable(atc.skillList)
      );
      this.dataAccordion = new Accordion(accordionHeader, accordionData);
      this.totalAccordions.push(this.dataAccordion);
    }

    this.timeInvested = this.secondsToHms(timeInvestedTotal);
    this.pieChartData = [
      this.unattemptedATCCount,
      this.inprogressATCCount,
      this.completeATCCount,
    ];
    this.totalAtcCount = this.autoTrainingCodeList.length;
    this.trainingDeadlineDate = dueDate
      ? this.formatDate(this.dateConversion(dueDate))
      : 'N/A';
    this.remainingDays = dueDate
      ? this.calculateDaysDiff(this.dateConversion(dueDate))
      : 'N/A';
    this.legendData = [
      {
        itemValue: this.completeATCCount,
        labelName: this.chartLabels[0],
        colourIndicator: this.stringTableService.getString(
          'colors',
          'completeLabelColor'
        ),
      },
      {
        itemValue: this.inprogressATCCount,
        labelName: this.chartLabels[1],
        colourIndicator: this.stringTableService.getString(
          'colors',
          'inProgressLabelColor'
        ),
      },
      {
        itemValue: this.unattemptedATCCount,
        labelName: this.chartLabels[2],
        colourIndicator: this.stringTableService.getString(
          'colors',
          'unattemptedLabelColor'
        ),
      },
    ];
    this.setSelectedAccordianData();
  }

  formTable(skillList) {
    this.displayTable = [];
    for (const skill of skillList) {
      const exportOptions = {
        csvLogo:
          skill.questionCount === skill.itemCorrectForLastAttempt
            ? 'test-link-disabled'
            : null,
      };

      this.displayTable.push([
        new Table(
          Types.IMG_TEXT,
          this.getApplicationIconPath(skill.applicationName),
          skill.skillName,
          skill.skillLaunchLink,
          exportOptions,
          skill.skillId
        ),
        new Table(Types.TEXT, 'table-data', skill.questionCount),
        new Table(Types.TEXT, 'table-data', skill.itemCorrectForLastAttempt),
        new Table(Types.TEXT, 'table-data', skill.obtainedScore),
      ]);
    }
    return this.displayTable;
  }

  onExpansion(event, index) {
    this.expandData[index] = event.isExpanded;
  }

  onCheckBoxClicked(event, index) {
    if (event.self) {
      if (this.checkForOnlyOneCbClicked()) {
        event.self.isSelected = !event.self.isSelected;
        return;
      }
    }
    let checkFlag = false;
    if (event.checkboxState === CheckboxState.CHECKED) {
      checkFlag = true;
    }
    if (index === 0) {
      this.checkAllCb(checkFlag);
    } else {
      this.checkForAllCBChecked();
    }
    this.expandData = [];
  }

  checkForOnlyOneCbClicked() {
    let count = 0;
    for (const checkbox of this.allCheckBoxes) {
      if (checkbox.isSelected) {
        count++;
      }
    }
    if (count === 0) {
      return true;
    } else {
      return false;
    }
  }

  checkAllCb(checkFlag) {
    this.allCheckBoxes.forEach((checkbox) => {
      checkbox.isSelected = checkFlag;
    });
    this.initCheckedCategory();
    this.setSelectedAccordianData();
  }

  checkForAllCBChecked() {
    let allChecked = 0;
    let flag = false;
    const tempAccordion = [];
    this.allCheckBoxes.forEach((checkbox) => {
      if (checkbox.data !== 0 && checkbox.isSelected === true) {
        ++allChecked;
      }
    });
    if (allChecked === this.allCheckBoxes.length - 1) {
      flag = true;
    } else if (allChecked === 0) {
      this.initCheckedCategory();
    }
    this.setSelectedAccordianData();
    this.allCheckBoxes[0].isSelected = flag;
  }

  getCheckedCategoryData(checkedCategory) {
    const tempAccordion = [];
    for (const accordion of this.totalAccordions) {
      if (accordion.header.chartData.chartType === checkedCategory) {
        tempAccordion.push(accordion);
      }
    }
    return tempAccordion;
  }

  setSelectedAccordianData() {
    const tempAccordion = [];
    this.allCheckBoxes.forEach((checkbox) => {
      if (checkbox.isSelected === true) {
        const records = this.getCheckedCategoryData(checkbox.data);
        for (const record of records) {
          tempAccordion.push(record);
        }
      }
    });
    this.accordianToDisplay = this.sortAccordiansPerChartType(tempAccordion);
    this.shortSkillsAsperClientTrainingList(this.accordianToDisplay);
    this.accordianToDisplay = this.shortGroupAccToSkillName(
      JSON.parse(JSON.stringify(this.accordianToDisplay))
    );
  }

  initCheckedCategory() {
    this.allCheckBoxes.forEach((checkbox) => {
      if (
        checkbox.data === PieChartType.INPROGRESS ||
        checkbox.data === PieChartType.UNATTEMPTED
      ) {
        checkbox.isSelected = true;
      }
    });
  }

  accordionLinkClicked(event) {}

  secondsToHms(d) {
    d = Number(d);
    const h = Math.floor(d / 3600);
    const m = Math.floor((d % 3600) / 60);
    const s = Math.floor((d % 3600) % 60);
    if (h > 0) {
      return h + (h === 1 ? ' Hour' : ' Hours');
    } else {
      return m > 0 ? m + (m === 1 ? ' Minute' : ' Minutes') : '0';
    }
  }

  calculateDaysDiff(date) {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate = new Date(date);
    const secondDate = new Date();
    let diffDays = 0;
    if (firstDate > secondDate) {
      diffDays = Math.ceil(
        Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
      );
    }
    const daysString =
      diffDays > 0 ? diffDays + (diffDays === 1 ? ' day' : ' days') : diffDays;
    return daysString;
  }

  onAutoTrainingClicked() {}

  onReportButtonClicked(event) {
    this.selectedElement = event.selectedElement;
    this.currentSelectedAccordion = this.autoTrainingCodeList.find(
      (record) => record.applicationId === event.applicationId
    );
    this.currentSelectedAccordion = {
      ...this.currentSelectedAccordion,
      candidateEmail: this.candidateEmail
    };
    this.currentSelectedAccordion = this.shortcurrentselectedAccordion(
      this.currentSelectedAccordion
    );
    this.popupState = true;
    this.pieChartItemValue = event.itemValue;
    this.pieChartPieChartType = event.pieChartType;
  }

  popupClose() {
    this.popupState = false;
    this.selectedElement.focus();
  }

  shortcurrentselectedAccordion(accordion) {
    for (const skill of accordion.skillList) {
      const index = this.findIndex(skill.skillId);
      if (index !== -1) {
        skill.priority = index;
      } else {
        skill.priority = 10000;
      }
    }
    accordion.skillList = this.shortAcordionSkillTopriority(accordion);
    return accordion;
  }

  shortAcordionSkillTopriority(accordion) {
    return accordion.skillList.sort(function (a, b) {
      return a.priority - b.priority;
    });
  }

  shortGroupAccToSkillName(acoredionData) {
    for (let a = 0; a < acoredionData.length; a++) {
      for (let b = a + 1; b < acoredionData.length; b++) {
        if (
          acoredionData[a].content.table[0][0].priority >
          acoredionData[b].content.table[0][0].priority
        ) {
          const temp = JSON.parse(JSON.stringify(acoredionData[b]));
          acoredionData[b] = JSON.parse(JSON.stringify(acoredionData[a]));
          acoredionData[a] = temp;
        }
      }
    }
    return acoredionData;
  }

  sortAccordiansPerChartType(array) {
    return array.sort(function (a, b) {
      return (
        a.header.chartData.chartType - b.header.chartData.chartType ||
        a.header.chartData.itemValue - b.header.chartData.itemValue
      );
    });
  }

  shortSkillsAsperClientTrainingList(acoredionData) {
    for (const acordion of acoredionData) {
      for (const row of acordion.content.table) {
        const index = this.findIndex(row[0].skillId);
        if (index !== -1) {
          row[0].priority = index;
        }
      }
      acordion.content.table = this.shortAcordionByPriority(
        JSON.parse(JSON.stringify(acordion.content.table))
      );
    }
  }

  shortAcordionByPriority(table) {
    return table.sort(function (a, b) {
      return a[0].priority - b[0].priority;
    });
  }

  findIndex(id) {
    const list = MainComponent.getTrainingList();
    for (let i = 0; i < list.length; i++) {
      if (list[i].skillId === id) {
        return i;
      }
    }
    return -1;
  }

  // Date conversion to iso format to support date comparisons of dates from date picker and date coming from API in cross browsers
  protected dateConversion(dateString): Date {
    if (dateString === null || dateString === undefined || dateString.length === 0) {
      return null;
    }
    const regEx = RegExp('(^\\d+-\\d+-\\d+)|(^\\d+\/\\d+\/\\d+)');
    const matchedDate = regEx.exec(dateString);
    let newDate = null;
    if (matchedDate) {
      newDate = new Date(matchedDate[0]);
    }
    return newDate;
  }
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/dashboard-home/dashboard-home.component.ts